<ng-container *ngIf="survey$ | async let data">
  <div
    [ngClass]="{ 'widget-content': expanded }"
    [@expand]="expanded ? 'expanded' : 'collapsed'"
  >
    <ng-container *ngIf="expanded">
      <ng-container *ngIf="widget?.key === widgets.groupedSurveys">
        <!-- Tracker Widget-->
        <ng-container *ngIf="widgetInfo.type === 'tracker'">
          <div>
            <ps-ui-manage-tracker
              [mcUniqueId]="survey.mc_unique_id!"
              [userType]="userType"
            ></ps-ui-manage-tracker>
          </div>
        </ng-container>

        <!-- Group MC Widget-->
        <ng-container *ngIf="widgetInfo.type === 'group-mc'">
          <div>
            <ps-ui-manage-multi-country
              [mcUniqueId]="survey.mc_unique_id"
              [surveyId]="survey.surveyId"
              [auth]="auth"
            ></ps-ui-manage-multi-country>
          </div>
        </ng-container>

        <!-- Group Survey Widget-->
        <ng-container *ngIf="widgetInfo.type === 'grouped'">
          <div>
            <ps-ui-manage-grouped-survey
              [parentSurvey]="data"
              [auth]="auth"
            ></ps-ui-manage-grouped-survey>
          </div>
        </ng-container>
      </ng-container>

      <!-- Traffic Channels Widget -->
      <ng-container *ngIf="widget?.key === widgets.traffic">
        <ps-ui-manage-traffic-channels
          [survey]="data"
          [canAddTrafficChannels]="false"
          [isDashboard]="isDasaboard"
          [dashbordTabStatus]="dashbordTabStatus"
          [isMultiCountryWidget]="isMultiCountryWidget"
        ></ps-ui-manage-traffic-channels>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
